function invokeOptionsProvider (provider, term, field) {
  if (typeof provider !== 'function') return Promise.resolve([])
  const mode = field.remoteProviderMode || 'field'
  if (mode === 'field') return Promise.resolve().then(() => provider(term, field))
  if (mode !== 'callback') return Promise.reject(new Error(`Modo de proveedor remoto inválido: ${mode}`))

  return new Promise((resolve, reject) => {
    let settled = false
    const settle = value => {
      if (settled) return
      settled = true
      resolve(value)
    }
    const fail = error => {
      if (settled) return
      settled = true
      reject(error)
    }

    let returned
    try {
      returned = provider(term, settle, field)
    } catch (error) {
      fail(error)
      return
    }

    if (returned && typeof returned.then === 'function') returned.then(settle, fail)
    else if (returned !== undefined) settle(returned)
  })
}

export { invokeOptionsProvider }
